export default __webpack_public_path__ + "static/media/floor-mounted.fcc53eb5.svg";